<template>
  <div class="access">
    <Loading :isLoading="this.isLoading"/>
    <Access v-on:search-info-by-rfc-nip="getResponseAccess($event)" 
      :showBackButton="true" backUrl="HomeLoanRequest" />
  </div>
</template>

<script>
import User from '@/classes/User'
import Loading from '@/components/Loading/Loading.vue'
import Access from '@/components/Forms/Access.vue'

export default {
  data() {
    return {
      rfc: "",
      nip: "",
      userObjectClass: null,
      isLoading: false,
    }
  },
  components: {
    Loading,
    Access
  },
  watch: {
    rfc(value) {
      var regex = /[^a-z0-9]/gi
      if (regex.test(value)) {
        this.rfc = this.rfc.replace(/[^a-z0-9]/gi, "");
      }
    }
  },
  mounted(){
    this.userObjectClass = new User();
  },
  methods: {
    getResponseAccess(event) {
      if (event.rfcIsValid) {
        this.setToLocalStorage("authenticate", event.data);
        this.$router.push({ name: 'PreRequestLoan' });
      }
    },
    setToLocalStorage(item, value) {
      window.localStorage.setItem(item, JSON.stringify(value));
    },
  }
}
</script>

<style scoped>
.preRequestLoanInput {
  width: 100%;
  border: solid 1px #12B3BD;
  border-radius: 3px;
  padding: 10px;
  color: #222222;
  font-family: Roboto;
  font-weight: 400;
}
input[type=text]:focus {
  box-shadow: 0 0 1pt 1pt #12B3BD;
  outline-width: 0px;
}
::placeholder {
  color: #222222;
  font-family: Roboto;
  font-weight: 400;
}
.upperCaseTransform {
  text-transform: uppercase;
}
.upperCaseTransform::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: none;
}
.upperCaseTransform:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
.upperCaseTransform::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: none;
}
.upperCaseTransform:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: none;
}
.upperCaseTransform::placeholder {
  text-transform: none;
}
.titleAccess {
  font-family: Roboto;
  font-weight: 400;
  font-size: 20px;
  color: #222222;
}
.access {
  margin-top:30px;
}
.AccessButton {
  width: 100%;
  height: 45px;
  background-color: #198F99;
  font-family: Roboto;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
  border-radius: 5px;
}
.AccessButtonWithoutBackground {
  width: 100%;
  height: 45px;
  background-color: #fff;
  border: 1px solid #198F99;
  font-family: Roboto;
  font-weight: 500;
  font-size: 18px;
  color: #222222;
  border-radius: 5px;
}
@media only screen and (min-width: 1024px) {
  .preRequestLoanInput {
    width: 40%;
  }
  .AccessButton {
    width: 40%;
  }
  .AccessButtonWithoutBackground {
    width: 40%;
  }
}
</style>
